import { gql } from '@apollo/client';

export const RENEW_OFFER = gql`
    mutation RenewOffer($offerNumber: String!) {
        renewOffer(offerNumber: $offerNumber) {
            id
        }
    }
`;
